module.exports = __webpack_public_path__ + "wave.svg?07335a69e4c601d8c0f0ae517971ddf8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wave.svg
// module id = 162
// module chunks = 0